import React from 'react';
import { appApiUrl } from '../../utils/appApiOrigin';
import { markSessionValid } from '../../utils/sessionAuth';
import { applySessionProfileFromApi } from '../../newsintelligence/profileIdentity/sessionProfile';
import {
  applyProfileAvatarImgFallback,
  buildProfilePictureUrlForMode,
} from '../../newsintelligence/MainHeader/profilePictureUrl';
import { getProductsTheme } from './productsThemeStore';

/**
 * Resolves whether the visitor has a session and loads profile for the products header.
 */
export function useProductsSession() {
  const [status, setStatus] = React.useState('loading');
  const [profile, setProfile] = React.useState(null);

  const load = React.useCallback(async () => {
    try {
      const res = await fetch(appApiUrl('/api/profile'), {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok && data?.userProfile) {
        const mapped = applySessionProfileFromApi(data);
        if (mapped?.userId) {
          markSessionValid();
          setProfile(mapped);
          setStatus('authenticated');
          return;
        }
      }
      setProfile(null);
      setStatus('guest');
    } catch {
      setProfile(null);
      setStatus('guest');
    }
  }, []);

  React.useEffect(() => {
    load();
  }, [load]);

  const avatarSrc = React.useMemo(() => {
    if (!profile?.userId) return '';
    return buildProfilePictureUrlForMode(
      profile.profilePictureUrl,
      process.env.REACT_APP_BASE_URL || '',
      profile.profileMode,
      {
        userId: profile.userId,
        name: profile.name,
        theme: getProductsTheme() === 'dark' ? 'dark' : 'light',
      }
    );
  }, [profile]);

  return { status, profile, avatarSrc, refreshSession: load, onAvatarError: applyProfileAvatarImgFallback };
}
